<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
.amap-info-content{
  border-radius: 10px;
background: #ECF3FC;
}
::-webkit-scrollbar {
    width: 0; /* 横向滚动条宽度 */
    height: 10px; /* 纵向滚动条高度 */
  }
  .el-dialog__headerbtn .el-dialog__close {
  color: #ffffff !important;
}
.el-tabs__item:hover {
  color: #ffffff !important;
}
.el-tabs__item.is-active {
  color: #ffffff !important;
}
.el-menu-item {
  background: #283847 !important;
}
.el-dialog {
  opacity: 1 !important;
  border-radius: 4px !important;
  background: rgb(0, 47, 126) !important;
}
.el-dialog__title {
  opacity: 1 !important;
  color: #ffffff !important;
  font-family: Source Han Sans !important;
  font-weight: medium !important;
  font-size: 16px !important;
  line-height: 16px !important;
  letter-spacing: 0px !important;
  text-align: left !important;
}
</style>


// WEBPACK FOOTER //
// src/App.vue